// @core/api/endpoints/affiliate/list_clicks.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListClicksResponse,
} from '../../../types/affiliate';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/affiliate';

/**
 * List clicks
 * Returns a paginated list of clicks. Supports filtering and sorting.
 */
export async function ListClicks(
  params?: PaginatedRequest & {
    affiliate_id?: string | number | boolean;
    campaign_id?: string | number | boolean;
    offer_id?: string | number | boolean;
    period_end?: string | number | boolean;
    period_start?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListClicksResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/clicks`;
  const requestOptions = options;
  return client.get<ListClicksResponse>(requestPath, { ...requestOptions, params });
}
